/** Extract the Unix-seconds expiry from a signed URL's `?e=<timestamp>` param. */
export function getUrlExpiry(url: string): number | null {
  const match = url?.match(/[?&]e=(\d+)/);
  return match ? parseInt(match[1], 10) : null;
}

/**
 * Returns true when the asset still has more than `extraBufferSec` seconds
 * before it expires. Returns true (assume valid) when the URL has no `e` param.
 */
export function isAssetValid(url: string, extraBufferSec = 0): boolean {
  const expiry = getUrlExpiry(url);
  if (expiry === null) return true;
  const nowSec = Math.floor(Date.now() / 1000);
  return expiry - nowSec > extraBufferSec;
}

/** Extra headroom on top of audio duration before play is blocked. */
export const AUDIO_BUFFER_SEC = process.env.NODE_ENV === "production" ? 120 : 30;

/** Minimum headroom required before enlarging an image. */
export const IMAGE_BUFFER_SEC = 20;
